import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, Truck, Globe, ShieldCheck, Search } from 'lucide-react';
import { CourierShell, C } from '../../components/courier/CourierUI';

export default function CourierHome() {
  const nav = useNavigate();
  const [awb, setAwb] = useState('');

  return (
    <CourierShell>
      {/* Hero */}
      <div className="rounded-3xl overflow-hidden mb-10" style={{ background: C.ink }}>
        <div className="px-8 py-12 md:px-14 md:py-16 relative">
          <div className="absolute top-0 right-0 h-full w-2/5 opacity-20"
               style={{ background: `repeating-linear-gradient(45deg, ${C.yellow}, ${C.yellow} 14px, transparent 14px, transparent 28px)` }} />
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white leading-none relative">
            Send anything,<br /><span style={{ color: C.yellow }}>anywhere.</span>
          </h1>
          <p className="text-white/70 mt-4 max-w-md text-base relative">
            Fast, tracked parcel delivery across Zambia and worldwide. Get an instant quote, ship in minutes, track every step.
          </p>
          <div className="flex flex-wrap gap-3 mt-8 relative">
            <button onClick={() => nav('/courier/quote')} data-testid="home-get-quote-btn"
              className="px-6 py-3 font-black text-black rounded-xl transition-transform hover:scale-105" style={{ background: C.yellow }}>
              Get a Quote
            </button>
            <button onClick={() => nav('/courier/ship')} data-testid="home-ship-now-btn"
              className="px-6 py-3 font-black text-white rounded-xl border-2 border-white/30 hover:bg-white/10">
              Ship Now
            </button>
          </div>
        </div>
      </div>

      {/* Track box */}
      <div className="bg-white rounded-2xl shadow-lg p-6 -mt-16 relative z-10 max-w-2xl mx-auto border border-black/5">
        <p className="font-black text-lg mb-3">Track your shipment</p>
        <div className="flex gap-2">
          <input value={awb} onChange={(e) => setAwb(e.target.value.toUpperCase())}
            placeholder="Enter AWB e.g. TKS-1234-5678" data-testid="home-track-input"
            className="flex-1 px-4 py-3 rounded-xl border border-black/15 font-mono text-sm focus:outline-none focus:ring-2 focus:ring-black"
            onKeyDown={(e) => e.key === 'Enter' && awb && nav(`/courier/track/${awb.trim()}`)} />
          <button onClick={() => awb && nav(`/courier/track/${awb.trim()}`)} data-testid="home-track-btn"
            className="px-5 rounded-xl font-black text-black flex items-center gap-1" style={{ background: C.yellow }}>
            <Search className="h-4 w-4" /> Track
          </button>
        </div>
      </div>

      {/* Features */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-12">
        {[
          { icon: Package, t: 'Instant Quotes', d: 'Zone-based pricing in seconds with a shareable QR.' },
          { icon: Truck, t: 'Pickup or Drop-off', d: 'We collect, or drop at a Tekstar service point.' },
          { icon: Globe, t: 'Domestic & Global', d: 'Across Zambia and international with customs support.' },
          { icon: ShieldCheck, t: 'Tracked & Insured', d: 'Live status and optional declared-value cover.' },
        ].map((f) => (
          <div key={f.t} className="bg-white rounded-2xl p-5 border border-black/5">
            <div className="h-10 w-10 rounded-xl flex items-center justify-center mb-3" style={{ background: C.yellow }}>
              <f.icon className="h-5 w-5 text-black" strokeWidth={2.5} />
            </div>
            <p className="font-black">{f.t}</p>
            <p className="text-sm text-black/60 mt-1">{f.d}</p>
          </div>
        ))}
      </div>
    </CourierShell>
  );
}
